import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Body from '../body/Fundamentals';
import Hero from '../hero/hero';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="fundamentals" 
        linkname="Mastering Fundamentals" 
        linklevel="1" 
        linktoone="" 
        linknameone=""
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Hero 
        paddingTop = "0px"
        id="1" 
        contentId = "1"
        height="300" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(0,0,0,1) 73%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#000" 
        backgroundPosition="right"
        borderwidth="0"
        bordercolor="#FFF"
        bordertype="solid"
        maxWidth="1400px"
        margin="auto"  >
      </Hero>
      <Body id="2"></Body>
    </>
  );
}

export default Index;
